import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';

export const StyledSection = styled(Section)`
  order: 4;
  background: var(--Primary-Skychain, #4169e1);
  padding: 20px 24px 40px 24px !important;
  margin: 0px !important;
  padding: 40px 20px !important;
  gap: 40px;
  align-self: stretch;

  ${media.md`
    padding: 60px 44px !important;
    gap: 60px;
  `}

  ${media.lg`
    padding: 80px 160px !important;
    gap: 60px;
  `}
`;

export const StyledContentBlock = styled.div`
  padding: 0px !important;
  margin: auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const Contentwrapper = styled.div`
  display: flex;

  align-items: center;
  gap: 40px;
  flex-direction: column;
  ${media.md`
    
    gap: 40px;
  `}

  ${media.lg`
   
    gap: 60px;
    flex-direction: row;
  `}
  ${media.xl`
    max-width: 1064px;
    align-items: flex-start;
  `}
`;

export const RewardImage = styled.img`
  width: 188px;
  height: 240px;
  flex-shrink: 0;
`;

export const Textwrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--regular, 50px);
  flex: 1 0 0;
  align-self: stretch;
`;

export const Titlewrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--small, 25px);
  align-self: stretch;
  ${media.lg`
    align-items: flex-start;
  `}
`;

export const Title = styled.h2`
  color: var(--Primary-White-Paper, #fff);
  text-align: center;
  font-family: 'Elza Condensed', sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 900;
  line-height: 85%; /* 81px */
  letter-spacing: -0.8px;
  text-transform: uppercase;
  display: flex;
  margin: 0px;
  ${media.md`
    font-size: 60px;
    line-height: 90%;
    letter-spacing: -1.2px;
  `}
  ${media.lg`
    font-size: 80px;
    letter-spacing: -1.8px;
    text-align: start;
  `}
  ${media.xl`
    font-size: 90px;
  `}
`;

export const Subtitle = styled.p`
  color: var(--Primary-White-Paper, #fff);
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 123%;
  margin: 0px;
  text-align: center;

  ${media.md`
    font-size: 18px;
  `}

  ${media.lg`
    font-size: 20px;
    text-align: start;
  `}
  ${media.xl`
    font-size: 22px;
  `}
`;
